export const localeData = {
    format: 'yyyy/mm/dd',
    separator: ' - ',
    cancelLabel: 'キャンセル',
    applyLabel: '更新する',
    customRangeLabel: 'カスタム',
    daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: ['１月', '２月', '３月', '４月', '５月', '６月', '７月', '８月', '９月', '１０月', '１１月', '１２月']
  }

export default function customRange() {
  let today = new Date()
  today.setHours(0, 0, 0, 0)
  let endToday = new Date()
  endToday.setHours(23, 59, 59, 99)

  return {
      '今日': [today, endToday],
      '1週間': [getDateBefore(6), endToday],
      '30日間': [getDateBefore(29), endToday], 
      '今月': [new Date(today.getFullYear(), today.getMonth(), 1), endToday],
      '先月': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      '今年': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
      '去年': [new Date(today.getFullYear(), today.getMonth() - 12, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
  }
}
export function getDateBefore(dateNum: any) {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let pickDate = new Date()
    pickDate.setDate(today.getDate() - dateNum)
    pickDate.setHours(0, 0, 0, 0);
    return pickDate
  }
  